<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';
import AuthScreenLayout from '@/layout/AuthScreenLayout.vue';
import { transientState } from '@/integrations/Immersve/auth/TransientState';

const route = useRoute();
const router = useRouter();

function queryValue(name: string): string | undefined {
  const value = route.query[name];
  return typeof value === 'string' ? value : undefined;
}

onMounted(() => {
  transientState.saveReturnTo(queryValue('returnTo'));
  const reason = queryValue('reason');
  router.replace({ path: '/login', query: reason ? { reason } : {} });
});
</script>

<template>
  <AuthScreenLayout>
    <div class="flex flex-col items-center" data-test="screen-auth-redirect">
      <ArrowPathIcon class="size-10 animate-spin text-gray-400" aria-hidden="true" />
      <span class="sr-only">Taking you to sign in</span>
    </div>
  </AuthScreenLayout>
</template>
